import {
  DropdownPrimeReact,
  DropdownPrimeReactProps,
} from "@finanedi.es/storybook"
import { keepPreviousData, useInfiniteQuery } from "@tanstack/react-query"
import { getContactosByFilterSimple } from "api/Contacto.service"
import { ContactoReadingSimpleDto } from "api/DTOs/ContactoReadingSimpleDto"
import { TFunction } from "i18next"
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"

interface FormikDocumentsProps extends DropdownPrimeReactProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  value: $TSMigrationFixMe
  onchange: ({ value }: { value: string }) => void
  disabled?: boolean
  pushDefaultOption?: Record<string, string>
}

const DropdownContactos = ({
  value,
  onchange,
  pushDefaultOption,
  disabled = false,
  ...props
}: FormikDocumentsProps) => {
  const { t }: { t: TFunction } = useTranslation()

  const [contactos, setContactos] = useState<ContactoReadingSimpleDto[]>([])

  const [keyWord, setKeyWord] = useState("")
  const { data, fetchNextPage, isFetchingNextPage, refetch } = useInfiniteQuery(
    {
      // eslint-disable-next-line @tanstack/query/exhaustive-deps
      queryKey: ["getContactosByFilterSimple", props?.id],
      queryFn: ({ pageParam = 0 }) => {
        return (
          !disabled &&
          getContactosByFilterSimple({
            queryParams: {
              Keyword: keyWord,
              SkipCount: pageParam,
            },
          })
        )
      },
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      getNextPageParam: (lastPage: $TSMigrationFixMe) => {
        return lastPage?.currentPage &&
          lastPage.currentPage * 10 < lastPage?.totalCount
          ? lastPage.currentPage * 10
          : undefined
      },
      initialPageParam: 0,
      placeholderData: keepPreviousData,
      refetchOnWindowFocus: false,
      retry: false,
    }
  )

  useEffect(() => {
    const nuevosContactos = data?.pages?.flatMap((page) => page?.items) ?? []

    const contactosFiltrados = nuevosContactos.filter(
      (contacto) => contacto !== null && contacto !== undefined
    )

    if (contactosFiltrados.length > 0) {
      setContactos(contactosFiltrados as ContactoReadingSimpleDto[])
    }
  }, [data, disabled])

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const loadMoreData = (event: $TSMigrationFixMe) => {
    if (!isFetchingNextPage && event.last === contactos.length) {
      if (
        data &&
        data.pages &&
        data.pages.length > 0 &&
        contactos.length <= data.pages[0].totalCount
      ) {
        fetchNextPage()
      }
    }
  }

  const onContactoFilter = async ({ filter }: { filter: string }) => {
    await setKeyWord(filter)
    refetch()
  }

  return (
    <DropdownPrimeReact
      panelClassName='!tw-z-50 !tw-max-w-[600px]'
      value={value}
      placeholder={`${t("remesas.edit.form.placeholderContacto")}`}
      onChange={onchange}
      style={{ maxWidth: "100%" }}
      options={
        pushDefaultOption ? [...contactos, pushDefaultOption] : contactos
      }
      optionLabel='razonSocial'
      optionValue='empresaContactoId'
      className='!tw-rounded !tw-max-w-full !tw-w-full tw-border-1 !tw-h-10 tw-items-center tw-align-middle !tw-p-0 tw-mb-2'
      filter
      emptyMessage={`${t("cuentasContables.notElementAccounts")}`}
      scrollHeight='350px'
      filterMatchMode='contains'
      onFilter={onContactoFilter}
      virtualScrollerOptions={{
        lazy: true,
        onLazyLoad: loadMoreData,
        itemSize: 38,
        showLoader: false,
      }}
      disabled={disabled}
      {...props}
    />
  )
}

export default DropdownContactos
